import './Sidebar.scss'

import type { MenuProps } from 'antd'
import { Drawer, Menu } from 'antd'
import classNames from 'classnames'
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { menuItems } from '../menu-items/menuItems'

type MenuItem = Required<MenuProps>['items'][number]

interface SidebarProps {
  isSmallScreen: boolean
  drawerVisible: boolean
  logo: string
  setDrawerVisible: Dispatch<SetStateAction<boolean>>
  userData: null
}

// Menü öğelerini Ant Design'ın desteklediği formata dönüştür
const items: MenuItem[] = menuItems.map(({ key, label, icon }) => ({
  key,
  label,
  icon,
}))

const Sidebar: React.FC<SidebarProps> = ({ drawerVisible, setDrawerVisible, isSmallScreen, logo }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedKey, setSelectedKey] = useState<string>('')

  useEffect(() => {
    const selectedItem = menuItems.find((item) => item.path === location.pathname)
    if (selectedItem) {
      setSelectedKey(selectedItem.key)
    }
  }, [location.pathname])

  const handleMenuClick = ({ key }: { key: string }) => {
    const selectedItem = menuItems.find((item) => item.key === key)

    if (selectedItem) {
      if (selectedItem.path === '/') {
        window.location.href = '/v1/'
      } else {
        navigate(selectedItem.path!)
      }
    }
  }

  return (
    <>
      {/* Küçük ekranlar için Drawer */}
      {isSmallScreen ? (
        <Drawer
          title={<img width={100} height={100} src={logo} alt="Logo" className="sidebar-logo" />}
          placement="left"
          closable={true}
          onClose={() => setDrawerVisible(false)}
          open={drawerVisible}
        >
          <Menu
            defaultSelectedKeys={['0']}
            mode="inline"
            items={items}
            selectedKeys={[selectedKey]} // Use selectedKey to highlight the active item
            onClick={handleMenuClick}
          />
        </Drawer>
      ) : (
        // Büyük ekranlar için Sidebar
        <div className={classNames('db-admin-sidebar')}>
          <div className="sidebar-logo">
            <img src={logo} alt="Logo" />
          </div>
          <Menu
            defaultSelectedKeys={['0']}
            mode="inline"
            items={items}
            selectedKeys={[selectedKey]} // Use selectedKey to highlight the active item
            onClick={handleMenuClick}
          />
        </div>
      )}
    </>
  )
}

export default Sidebar
